import React from 'react'
import PropTypes from 'prop-types'
import { GENDER } from '../../../../constant/GENDER'
import RegisteredFormField from '../../../common/RegisteredFormField'

const GenderSelect = ({ rootPath }) => {
  return <RegisteredFormField
    inputType='select'
    path={`${rootPath}.gender`}
    id='gender'
    options={GENDER}
    label='Gender'
    placeholder=' '
  />
}

GenderSelect.propTypes = {
  /** The redux object root path for this form field's parent */
  rootPath: PropTypes.string.isRequired,
}

export default GenderSelect